document.addEventListener('DOMContentLoaded', function() {
  // Find all tab containers
  const tabContainers = document.querySelectorAll('.tabs-container');

  tabContainers.forEach(function(container) {
    const tabButtons = container.querySelectorAll('.tab-button');
    const tabContents = container.querySelectorAll('.slide-tab-content');
    const tabsHeader = container.querySelector('.tabs-header');
    let touchStartX = 0;
    let touchEndX = 0;
    let currentTabIndex = 0;

    // Function to activate a specific tab within this container
    function activateTab(index) {
      // Remove active class from all buttons and contents in this container
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));

      // Add active class to the target button and content
      tabButtons[index].classList.add('active');
      const tabId = tabButtons[index].getAttribute('data-tab');
      const tabContent = container.querySelector(`#${tabId}`);
      if (tabContent) {
        tabContent.classList.add('active');
      }
      currentTabIndex = index;

      // Scroll the active tab into view
      if (tabsHeader) {
        const activeButton = tabButtons[index];
        const containerRect = tabsHeader.getBoundingClientRect();
        const buttonRect = activeButton.getBoundingClientRect();

        // Calculate scroll position to center the active tab
        const scrollLeft = tabsHeader.scrollLeft;
        const buttonOffset = buttonRect.left - containerRect.left;
        const buttonWidth = buttonRect.width;
        const containerWidth = containerRect.width;

        const targetScroll = scrollLeft + buttonOffset - (containerWidth / 2) + (buttonWidth / 2);

        // Smooth scroll to the target position
        tabsHeader.scrollTo({
          left: targetScroll,
          behavior: 'smooth'
        });
      }
    }

    // Click event handling for this container
    tabButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        activateTab(index);
      });
    });

    // Touch event handling for swipe on content in this container
    tabContents.forEach(content => {
      content.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, false);

      content.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      }, false);
    });

    function handleSwipe() {
      const swipeThreshold = 50; // Minimum distance for swipe detection
      const swipeDistance = touchEndX - touchStartX;

      if (Math.abs(swipeDistance) > swipeThreshold) {
        if (swipeDistance > 0) {
          // Swipe right - go to previous tab
          if (currentTabIndex > 0) {
            activateTab(currentTabIndex - 1);
          }
        } else {
          // Swipe left - go to next tab
          if (currentTabIndex < tabButtons.length - 1) {
            activateTab(currentTabIndex + 1);
          }
        }
      }
    }

    // Initialize first tab as active for this container
    if (tabButtons.length > 0) {
      activateTab(0);
    }
  });

});